import { api } from '../api';

export const uploadUserFacsimile: (file: File) => Promise<void> = (file: File): Promise<void> => {
  const formData: FormData = new FormData();
  formData.append('facsimile', file);

  return api.post('users/profile/facsimile', formData, { customEnv: { notEncryptedRequest: true } });
};

export const downloadUserFacsimile: () => Promise<string> = (): Promise<string> => api.get(
  'users/profile/facsimile', { customEnv: { notEncryptedResponse: true } }
);

export const updateAvatar: (file: File) => Promise<void> = (file: File): Promise<void> => {
  const formData: FormData = new FormData();
  formData.append('avatar', file);

  return api.post('users/profile/avatar', formData, { customEnv: { notEncryptedRequest: true } });
};

export const removeAvatar: () => Promise<string> = (): Promise<string> => api.delete('users/profile/avatar');

// TODO: uncomment when proxy for this endpoint will work on be node
// export const getUserInfo: () => Promise<UserInfoInterface> = (): Promise<UserInfoInterface> => api.get('v1/users/info');
